import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { TagsFieldWUT } from '../../../ui/tags-field';
export const TagsWUT = props => {
  const fieldType = FIELD_TYPES.TAGS;
  return /*#__PURE__*/React.createElement(TagsFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
};
//# sourceMappingURL=tags-wut.js.map